import { createSlice } from "@reduxjs/toolkit";

export const packageSlice = createSlice({
    name: "package",
    initialState: {
        packages: [],
        loading: false,
        error: null,
    },
    reducers: {
        setLoading: (state) => {
            state.loading = true;
            state.error = null;
        },
        setPackages: (state, action) => {
            state.loading = false;
            state.error = null;
            state.packages = action.payload.data;
        },
        setError: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
})

export const {
    setLoading,
    setPackages,
    setError,
} = packageSlice.actions;

export default packageSlice.reducer;
